import {
	BROADBAND_GUIDES_HEADER_CONTENT,
	BROADBAND_GUIDES_SEO,
} from "@/data/consts";
import * as React from "react";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import PageSEO from "@/components/Shared/PageSEO";
import { getOne, getArticlesByTag } from "@/api/contentful";
import ArticlesList from "@/components/Article/ArticleList";
import { Article, PageSEO as PageSEOType } from "@/types/index";
import HeaderContent from "@/components/Comparison/HeaderContent";
import { HeaderContent as HeaderContentType } from "@/types/header";

const Breadcrumbs = [
	{
		title: "Home",
		href: "/",
		active: false,
	},
	{
		title: "Broadband",
		href: "/broadband",
		active: false,
	},
	{
		title: "Broadband Guides",
		href: "/broadband/guides",
		active: true,
	},
];

const BroadbandGuides: React.FC<{
	pageSEO: PageSEOType;
	headerContent: HeaderContentType;
	articles: Array<Article>;
}> = ({ pageSEO, headerContent, articles }) => {
	return (
		<>
			<PageSEO
				title={pageSEO.fields.pageTitle}
				description={pageSEO.fields.metaDescription}
				keywords={pageSEO.fields.metaKeywords}
			/>
			<Header
				left={<HeaderContent data={headerContent} />}
				right={<></>}
				breadcrumbs={Breadcrumbs}
			/>

			<ArticlesList articles={articles} />
			<Footer />
		</>
	);
};

export async function getStaticProps() {
	const pageSEO = await getOne(BROADBAND_GUIDES_SEO);
	const headerContent = await getOne(BROADBAND_GUIDES_HEADER_CONTENT);
	const articles = await getArticlesByTag("broadbandGuides");

	return {
		props: {
			pageSEO,
			headerContent,
			articles,
		},
		revalidate: Number(process.env.REVALIDATE_CONTENTFUL),
	};
}

export default BroadbandGuides;
